// extracted by mini-css-extract-plugin
export default {"btn_wishlist_wrapper":"WishlistButton_btn_wishlist_wrapper__ve2SD","btn_heart":"WishlistButton_btn_heart__wXdCV","active_wishlist":"WishlistButton_active_wishlist__x6jRe"};